import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// styles
import {
  ProgressBarStyled,
  ProgressBarContainerStyled,
} from './styles';

export const ProgressBarComponent = ({
  branding = 'nm',
  className,
  fillPercentage = 0,
  labelText,
  themeType = 'lightTheme',
}) => (
  <ProgressBarContainerStyled className={classNames('nmx-no-print', className)}>
    <label>
      {' '}
      {/** TODO: will have to come back to this - thinking <label> is not the best markup here... probably just a div or span. This labelText should also receive themeType */}
      {labelText}
      <ProgressBarStyled
        branding={branding}
        className="nmx-progress-bar"
        max="100"
        themeType={themeType}
        value={fillPercentage}
      />
    </label>
  </ProgressBarContainerStyled>
);
ProgressBarComponent.propTypes = {
  /** sets overall branding of component or module, default='nm' */
  branding: PropTypes.oneOf(['nm', 'pcg']),
  /** Optional custom class name */
  className: PropTypes.string,
  /** The progress percentage of the progress bar */
  fillPercentage: PropTypes.number.isRequired,
  /** required ariaLabel attribute, used for ADA to add more description to the progress bar (what ) */
  labelText: PropTypes.string,
  /** Optional themeType */
  themeType: PropTypes.oneOf(['lightTheme', 'darkTheme']),
};

export default ProgressBarComponent;
